import React from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import { connect } from 'react-redux';
import { Card, Col, Row, Table, Alert } from 'reactstrap';
import { MdCheck } from 'react-icons/md';
import { BsBellFill } from "react-icons/bs";
import { Spinner } from 'react-bootstrap';
import ListNotiAdminComponent from '../../../components/Admin/noti_admins/ListNotiAdminComponent';
import PaginateComponent from  '../../../components/PaginateComponent';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';

class NotiAdminPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			error: false,
			perPage: 0,
			totalPage: 0,
			currentPage: 0,
			from: '',
            to: '',
			messageError: '',
			isNotification: '',
			textNotification: '',
			isSpinner: false,
			listNotiAdmin: [],
			checkedNotiAdminIds: [],
			rq_table: {
                per_page: 10,
                page: 0,
                s: '',
                order_by: 'id',
                order: 'desc',
            },
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getListNotiAdmin();
		this.getUnReadNotiAdmins();
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	getListNotiAdmin = () => {
		this.setState({
			isLoading: true
		});

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: this.state.rq_table
		}
		axios.get( process.env.REACT_APP_API_URL + '/api/admin/noti-admin/list', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					listNotiAdmin: ref.data.content.data,
					rq_table: ref.data.content.filters,
					perPage: ref.data.content.perPage,
                    totalPage: ref.data.content.total,
                    currentPage: ref.data.content.current_page,
                    from: ref.data.content.from,
                    to: ref.data.content.to
				});
				this.state.listNotiAdmin.forEach( alert => {
					alert.checked = false;
		        });
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false,
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			});
		})
	}

    getUnReadNotiAdmins = () => {
	    let dataAuth = {
	        username: process.env.REACT_APP_CLIENT_ID,
	        password: process.env.REACT_APP_CLIENT_PASSWD,
	        token: process.env.REACT_APP_KEY,
	    };

	    let config = {
	        headers: {
		        'Content-Type': 'application/json',
		        'Authorization' : this.props.token,
		        'dataAgency' : JSON.stringify(dataAuth)
	        }
	    }

	    axios.get(process.env.REACT_APP_API_URL + '/api/admin/noti-admin/get-unread-noti-admin', config )
	    .then((ref) => {
	        // console.log(ref.data);
	        if (ref.data.error === 0) {
	            this.updateNotiAdmin(ref.data)
	        } else {
	            if (ref.data.error > 9000) {
	                this.props.logOut();
	            } else {
	                this.setState({
	                    error: true,
	                    messageError: ref.data.message
	                })
	            }
	        }
	    })
	    .catch((error) => {
	        console.log(error);
	        this.setState({
	            error: true,
	            messageError: 'Lấy dữ liệu thông báo thất bại',
	        })
	    })
    }

    updateNotiAdmin = (data) => {
        let itemNotiAdmin = {
            noti_admins: data.noti_admins,
            unread_noti_admin: data.unread_noti_admin
        }
        this.props.updateNotiAdmin(itemNotiAdmin);
    }

	listNotiAdminRow = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listNotiAdmin.length ) {
                return (
                    this.state.listNotiAdmin.map( (noti, key) => {
                        return (
                            <ListNotiAdminComponent
	                            key={key}
	                            noti={noti}
	                            actionKey={key}
	                            checkedNotiAdmin = { (actionKey) => this.checkedNotiAdmin(actionKey) }
                                checkedNotiAdminShiftKey = { (actionKey, value) => this.checkedNotiAdminShiftKey(actionKey, value) }
                            />
                        )
                    })
                );
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có dữ liệu!
                        </td>
                    </tr>
                );
            }
        }
    }

    checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	sort = (order_by) => {
		this.setState(
			{
				rq_table: {
			        ...this.state.rq_table, 
					order_by: order_by, 
					order: this.state.rq_table.order === 'desc' ? 'asc' : 'desc'
			    }
			},
			() => this.getListNotiAdmin()
		)
	}	

	change = (e) => {
		this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value,
					page: 0
			    }
			},
			() => this.getListNotiAdmin()
		)
	}

    search = (e) => {
	    this.setState(
	    	{
		    	rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value
			    }
		    }
	    )
    }

    submitSearch = (e) => {
        if(e.key === 'Enter') {
        	this.setState(
				{
					currentPage: 0,
					rq_table: {
				        ...this.state.rq_table,
						page: 0
				    }
				},
				() => this.getListNotiAdmin()
			)
        }
    }

    btnSearch = () => {
        this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table,
					page: 0
			    }
			},
			() => this.getListNotiAdmin()
		)
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
		this.setState(
			{
				currentPage: page,
				rq_table: {
			        ...this.state.rq_table, 
					page: page
			    }
			},
			() => this.getListNotiAdmin()
		)
    }

    checkAll = (e) => {
        let value = e.target.checked;
        let listNotiAdmin = this.state.listNotiAdmin;
        listNotiAdmin.forEach( noti => {
            noti.checked = value;
        });
        this.setState({
            checkAll: value,
            listNotiAdmin: listNotiAdmin
        });
        this.checkedNotiAdminIds(listNotiAdmin);
    }


    checkedNotiAdmin  = (actionKey) => {
        let listNotiAdmin = this.state.listNotiAdmin;
        listNotiAdmin[actionKey].checked = !listNotiAdmin[actionKey].checked;
        this.setState({
            listNotiAdmin: listNotiAdmin,
            checkedStart: actionKey
        });
        this.checkedNotiAdminIds(listNotiAdmin);
    }

    checkedNotiAdminShiftKey = (actionKey, value) => {
        if ( this.state.checkedStart !== -1 ) {
            let listNotiAdmin = this.state.listNotiAdmin;
            let n = Math.abs( actionKey - this.state.checkedStart );
            let i = this.state.checkedStart;
            let k = actionKey;
            if ( actionKey < this.state.checkedStart ) {
                i = actionKey;
                k = this.state.checkedStart;
            }
            for (i; i <= n; i++) {
                listNotiAdmin[i].checked = value;
            }
            this.setState({
                listNotiAdmin: listNotiAdmin,
                checkedStart: k
            });
            this.checkedNotiAdminIds(listNotiAdmin);
        } else {
            let listNotiAdmin = this.state.listNotiAdmin;
            listNotiAdmin[actionKey].checked = !listNotiAdmin[actionKey].checked;
            this.setState({
                listNotiAdmin: listNotiAdmin,
                checkedStart: actionKey
            });
            this.checkedNotiAdminIds(listNotiAdmin);
        }
    }

    checkedNotiAdminIds = (listNotiAdmin) => {
    	let checkedNotiAdminIds = [];
    	listNotiAdmin.forEach( alert => {
    		if (alert.checked) {
    			checkedNotiAdminIds.push(alert.id)
    		}
        });
        this.setState({
        	checkedNotiAdminIds: checkedNotiAdminIds
        })
    }

    confirmCheckedNotiAdmin = () => {
    	if (this.state.checkedNotiAdminIds.length) {
    		confirmAlert({
		      	title: '',
		      	message: 'Đã xem các thông báo được chọn?',
		      	buttons: [
			        {
			          	label: 'Xác nhận',
			          	onClick: () => { this.confirmCheckedNotiAdminRequest() }
			        },
			        {
			          	label: 'Hủy',
			          	onClick: () => false
			        }
		      	]
		    });
    	} else {
    		confirmAlert({
		      	title: '',
		      	message: 'Bạn chưa chọn mục để đánh dấu?',
		      	buttons: [
			        {
			          	label: 'OK',
			          	onClick: () => false
			        }
		      	]
		    });
    	}
    }

    confirmCheckedNotiAdminRequest = () => {

    	let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};
		let params = {ids: this.state.checkedNotiAdminIds}
		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			}
		}

		axios.post( process.env.REACT_APP_API_URL + '/api/admin/noti-admin/multi-confirm-read', params, config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
				isNotification: '',
				textNotification: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
					checkedNotiAdminIds: [],
				},
				() => this.getListNotiAdmin()
				);
				this.getUnReadNotiAdmins();
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
    }

    loadQttChecked = () => {
        let n = 0;
        if ( this.state.listNotiAdmin.length ) {
            this.state.listNotiAdmin.forEach( alert => {
                if ( alert.checked ) {
                    n++;
                }
            })
        }
        return (n);
    }

	render() {
		return (
			<>
                <Breadcrumb title={"Thông báo"} page={"Thông báo"} icon={<BsBellFill className="breadcrumb-icon" />} />

                <Row style={{ marginTop: 20 }}>
					<Col sm={12}>
						{ this.state.error ? (<Alert color="danger"><div className='text-center'>{ this.state.messageError }</div></Alert>) : (<></>)}
						{this.checkNotification()}
					</Col>
				</Row>

                <Card body>
                    <Row>
                    	<Col sm={12}>
							<button
								className={`btn btn-${this.state.checkedNotiAdminIds.length ? 'success' : 'outline-success'} btn-sm mb-3 mx-2 `}
								onClick={ () => this.confirmCheckedNotiAdmin() }
							>
								<MdCheck /> Đánh dấu đã xem
							</button>
						</Col>
						{
	                        this.state.listNotiAdmin.length ? (
	                        	<>
	                        		<Col md={12}>
		                                Hiển thị từ { this.state.from } đến { this.state.to } / Tổng: { this.state.totalPage }
		                            </Col>
		                            <Col md={12} className="text-primary mb-3">
				                        <b>
				                            Đã chọn:
				                            <span className="qtt-checkbox"> { this.loadQttChecked() }</span> / <span className="total-item">{ this.state.listNotiAdmin.length }</span>
				                        </b>
				                    </Col>
	                	 		</>
	                        ) : (
	                        <></>
	                        )
	                    }
                    	<Col sm={12} className="table-responsive">
                    		<Table className="table table-sm table-bordered table-hover rounded text-center">
		                        <thead className="primary">
		                            <tr>
		                            	<th className="text-center" width="5%">
		                            		<input
									          	type="checkbox"
									          	defaultValue={false}
									          	onChange={ this.checkAll }
									        />
		                            	</th>
		                                <th className={'text-center'} width="30%">Thời gian</th>
		                                <th className={'text-center'} width="65%">Thông báo</th>
		                            </tr>
		                        </thead>
		                        <tbody>
		                            { this.listNotiAdminRow() } 
		                        </tbody>
		                    </Table>
		                    <Row>
		                    	{
			                        this.state.listNotiAdmin.length ? (
			                        	<>
			                        		<Col md={12} className="mb-2">
				                                Hiển thị từ { this.state.from } đến { this.state.to } / Tổng: { this.state.totalPage }
				                            </Col>
			                	 		</>
			                        ) : (
			                        <></>
			                        )
			                    }
		                    </Row>
		                    { this.paginate() }
                    	</Col>
                    </Row>
                </Card>
            </>	
		)
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
		noti_admins: state.agency.noti_admins,
    	unread_noti_admin: state.agency.unread_noti_admin,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminNotification' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
		updateNotiAdmin: (item) => {
            dispatch(({type: 'updateNotiAdmin', item}))
        },
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(NotiAdminPage);